module.exports = __webpack_public_path__ + "static/img/coupondefault.30bf4db4.png";